import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppSettingsService, FilesService } from './../../../services';

@Component({
  selector: 'app-dialog-gallery',
  templateUrl: './dialog-gallery.component.html',
  styleUrls: ['./dialog-gallery.component.scss']
})
export class DialogGalleryComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<DialogGalleryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    // private ngZone: NgZone,
    private _files: FilesService,
    // private _appSettings: AppSettingsService
  ) { }

  baseUrlPhoto = AppSettingsService.API_ENDPOINT_PHOTOSTORE;
  selectedPhotoId = undefined;
  loading = false;
  list: any[] = [];

  page = 0;
  size = 20;
  first = false;
  last = false;
  totalPages = 0;
  pagesList = [];

  getArrayOfAllPages(count): any[] {
    let a = new Array(count);
    for (let i = 0; i < a.length; i++) a[i] = i;
    return a;
  }

  pageDOWN() {
    this.page = this.page > 0 ? this.page - 1 : this.page;
    this.getList();
  }
  pageUP() {
    this.page = this.page < this.totalPages ? this.page + 1 : this.page;
    this.getList();
  }

  isSelected = () => isFinite(this.selectedPhotoId);

  clear() {
    this.selectedPhotoId = undefined;
  }

  getList(): void {
    this.loading = true;
    let filter = {
      page: this.page,
      size: this.size
    }
    this._files.list(filter).subscribe(
      res => {
        this.list = res.data;
        this.first = res.first;
        this.last = res.last;
        this.page = Number(res.page);
        this.totalPages = res.totalPages;
        this.pagesList = this.getArrayOfAllPages(this.totalPages)
        this.loading = false;
      },
      err => {
        console.error(err);
        this.loading = false;
      }
    )
  }

  done = ():void => {
    this.dialogRef.close(this.baseUrlPhoto + this.list[this.selectedPhotoId].path);
  }
  
  ngOnInit() {
    this.getList();
  }

}
